export default {
  'financialOverviewWidget.manageAccountList': 'Manage account list',
  'financialOverviewWidget.manageAccountsHeader.DEPOSIT': 'Deposit Accounts - Manage account list',
  'financialOverviewWidget.manageAccountsHeader.INVESTMENT':
    'Investment Accounts - Manage account list',
  'financialOverviewWidget.manageAccountsHeader.LOAN': 'Loan Accounts - Manage account list',
  'financialOverviewWidget.manageAccountsHeader.OTHER': 'Other Accounts - Manage account list',
  'financialOverviewWidget.manageAccountsDescription':
    'Use the lists below to add/remove accounts to be displayed. Drag & drop the accounts to set the order they will appear.',
  'financialOverviewWidget.manageAccounts.selectedColumnHeader': 'Financial Overview Account List',
  'financialOverviewWidget.manageAccounts.back.confirm':
    'Are you sure you want to leave? All unsaved changes will be lost.',
  'financialOverviewWidget.accordion.screenReaderHeader': 'View <%= accounts %>'
};
